import { Image, Input, Stack } from '@chakra-ui/react';
import { getAsset } from '@pelicargo/tenants';
import { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';

import { SimpleField } from './SimpleField';

type Props = {
  name: string;
  variant?: 'inline' | 'outline';
  hideLabel?: boolean;
};

export const SimpleSignature = ({ name, variant, hideLabel = false }: Props) => {
  const { watch, setValue } = useFormContext();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(name, event.target.value);
  };

  return (
    <SimpleField label={hideLabel ? '' : 'Type to Sign'} variant={variant}>
      <Stack direction="row" align="center" spacing="4">
        <Image src={getAsset('signature-label.svg')} h="40px" userSelect="none" />

        <Input
          name="signature"
          type="text"
          placeholder=""
          variant="unstyled"
          fontSize="4xl"
          fontStyle="italic"
          fontFamily="'Ephesis', cursive"
          w="full"
          value={watch(name)}
          onChange={handleChange}
        />
      </Stack>
    </SimpleField>
  );
};
